import { useState, useEffect } from 'react';
import { useTheme } from 'styled-components';

const ssrSafeGetMatches = (query) => {
    if (typeof window !== 'undefined') {
        return window.matchMedia(query).matches;
    }
    return false;
};
const useDevice = (breakpoint = 'lg') => {
    const theme = useTheme();
    const query = `(max-width: ${theme.breakpoints[breakpoint]})`;
    const [matches, setMatches] = useState(false);
    useEffect(() => {
        const matchMedia = window.matchMedia(query);
        const updateMatches = () => setMatches(ssrSafeGetMatches(query));
        updateMatches();
        if (matchMedia.addListener) {
            matchMedia.addListener(updateMatches);
        }
        else {
            matchMedia.addEventListener('change', updateMatches);
        }
        return () => {
            if (matchMedia.removeListener) {
                matchMedia.removeListener(updateMatches);
            }
            else {
                matchMedia.removeEventListener('change', updateMatches);
            }
        };
    }, []);
    return {
        isDesktop: !matches,
        isMobile: matches
    };
};

export { useDevice as default };
//# sourceMappingURL=useDevice.mjs.map
